import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Spinner } from "../../spinner";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const LoadingIndicator = props => /*#__PURE__*/React.createElement("div", _extends({
  style: props.getStyles("loadingIndicator", props)
}, props.innerProps), /*#__PURE__*/React.createElement(Spinner, {
  size: "small"
}));
//# sourceMappingURL=LoadingIndicator.js.map